function addTopLevelShimsToAppDef (appDef) {
  // dynamically modify appdef to make it work as a "list app"...
  // add a new model to serve as the top-level object:
  const topType = topLevelListType(appDef.mainType, appDef.label)
  appDef.types.push(topType)
  // swap this new model in for the previous mainType:
  appDef.mainType2 = appDef.mainType
  appDef.mainType = topType.name
  // modify the former mainType to add a "shim" formula that preserves functionality
  // of relevance expressions and anything else referring to "_" explicitly
  const mainType = appDef.types.find(t => t.name === appDef.mainType2)
  mainType.formulas.push({
    name: "_",
    type: "object",
    typeName: mainType.name,
    isList: false,
    expression: "_top_var[_index0]",
    tests: {},
    uses: {}
  })
  // suppress "select from" and/or "link to" functionality when running as list app
  if (appDef.selectFrom) {
    appDef.selectFrom2 = appDef.selectFrom
    appDef.selectFrom = ''
  }
  if (appDef.linkedQuery) {
    appDef.linkedQuery2 = appDef.linkedQuery
    appDef.linkedQuery = ''
  }
}
exports.addTopLevelShimsToAppDef = addTopLevelShimsToAppDef

function topLevelListType (mainTypeName, listLabel) {
  return {
    _id: '_top_inferred',
    name: '_top_inferred',
    type: 'object',
    label: '',
    summary: '',
    variables: [
      {
        'name': '_top_var',
        'type': 'object',
        'typeName': mainTypeName,
        'isList': true,
        'label': listLabel,
        'unlabeled': true,
        'style': 'popup',
        'f': 0,
        'tests': {},
        'uses': {
            '_': 'true'
        }
      }
    ],
    formulas: [],
    templates: [],
    layouts: [
      {
        name: '(default)',
        label: '',
        columnCount: 1,
        rows: [
          [
            {
              id: 1,
              content: '_top_var',
              list: [],
              class: 'question',
              expr: ''
            }
          ]
        ]
      }
    ],
    f: 0
  }
}
